import { deserializeToSpeechSegment, SpeechSegment } from "src/app/modules/speech2text/models/speech-segment.model";

export interface HomePage {
  title: string;
  firstParagraph: string;
  secondParagraph: string;
}

export interface HomePageFeature {
  id: string;
  title: string;
  segments: SpeechSegment[];
  description: string;
  videoUrl: string;
  instructions: string;
  transcript: string;
  featureStatus?: "ERROR" | "DOWNLOADING" | "TRANSCRIBING" | "GENERATING_INSTRUCTIONS" | "DONE";
}

export const deserialize = (input: Partial<HomePageFeature>): HomePageFeature => {
  if (!input.id) {
    throw new Error(`Missing id in homePageFeature=${JSON.stringify(input)}`);
  }
  const segments = input.segments?.map((segment) => deserializeToSpeechSegment(segment)) ?? [];
  return {
    id: input.id,
    title: input.title || "",
    segments,
    description: input.description || "",
    videoUrl: input.videoUrl || "",
    instructions: input.instructions || "",
    transcript: input.transcript || "",
    featureStatus: input.featureStatus,
  };
};
